import HashMake from '../../services/hash.service'
import {TokenService} from "../../services/storage.service";
import ApiService from "../../services/api.service";
import apiService from "../../services/api.service";

const getDefaultState = () => {
    return {
        cs_dealer : {
            name : "",
            email : "",
            phone : "",
            appointment : {
                date : "",
                time : ""
            },
            address : "",
            city : "",
            dealer_id : "",
            time_slots : []
        },
        cs_dealer_without_service : {
            name : "",
            email : "",
            phone : "",
            appointment : {
                date : "",
                time : ""
            },
            address : "",
            city : "",
            dealer_id : "",
            time_slots : []
        },
        cs_loader : false,
        is_with_service : false,
        live_cart : {
            products : []
        }
    }
}

const state = getDefaultState()

const getters = {
    cs_dealer : (state) => state.cs_dealer,
    cs_dealer_without_service : (state) => state.cs_dealer_without_service,
    cs_loader : (state) => state.cs_loader,
    is_with_service : (state) => state.is_with_service,
    live_cart : (state) => state.live_cart
}

const actions = {
    csSetName({commit}, name) {
        commit('csSetName', name);
    },
    csSetEmail({commit}, email) {
        commit('csSetEmail', email);
    },
    csSetDate({commit}, date) {
        commit('csSetDate', date);
    },
    csSetTime({commit}, time) {
        commit('csSetTime', time);
    },
    csSetPhone({commit}, phone) {
        commit('csSetPhone', phone);
    },
    csSetAddress({commit}, address) {
        commit('csSetAddress', address);
    },
    csSetCity({commit}, address) {
        commit('csSetCity', address);
    },
    csSetDealerId({commit}, dealer_id) {
        commit('csSetDealerId', dealer_id);
    },
    csSetTimeSlots({commit}, time_slots) {
        commit('csSetTimeSlots', time_slots);
    },
    csSaveDealerToLocalStorage({commit}) {
        commit('csSaveDealerToLocalStorage');
    },
    csSetDealerToLocalStorage({commit}) {
        commit('csSetDealerToLocalStorage');
    },
    csRemoveDealerFromLocalStorage({commit}) {
        commit('csRemoveDealerFromLocalStorage');
    },

    /*-- Without Service --*/
    csWOSetName({commit}, name) {
        commit('csWOSetName', name);
    },
    csWOSetEmail({commit}, email) {
        commit('csWOSetEmail', email);
    },
    csWOSetDate({commit}, date) {
        commit('csWOSetDate', date);
    },
    csWOSetTime({commit}, time) {
        commit('csWOSetTime', time);
    },
    csWOSetPhone({commit}, phone) {
        commit('csWOSetPhone', phone);
    },
    csWOSetAddress({commit}, address) {
        commit('csWOSetAddress', address);
    },
    csWOSetCity({commit}, address) {
        commit('csWOSetCity', address);
    },
    csWOSetDealerId({commit}, dealer_id) {
        commit('csWOSetDealerId', dealer_id);
    },
    csWOSetTimeSlots({commit}, time_slots) {
        commit('csWOSetTimeSlots', time_slots);
    },

    csWOSaveDealerToLocalStorage({commit}) {
        commit('csWOSaveDealerToLocalStorage');
    },
    csWOSetDealerToLocalStorage({commit}) {
        commit('csWOSetDealerToLocalStorage');
    },
    csWORemoveDealerFromLocalStorage({commit}) {
        commit('csWORemoveDealerFromLocalStorage');
    },

    /*--FLAG--*/
    csSetIsWithService({commit}, bool) {
        commit('csSetIsWithService', bool);
    },

    async getLiveCart({commit}, QueryString = null) {
        return new Promise((resolve, reject) => {
            var token = TokenService.getToken(), anonymousId = "", QueryStringObject = {}, ApiResource = null;
            if (QueryString && typeof QueryString === "object" && QueryString.hasOwnProperty("service_point_id")) {
                QueryStringObject.service_point_id = QueryString.service_point_id
            }

            if ("service" in localStorage && localStorage.getItem("service").length !== 0) {
                let services = localStorage.getItem("service").split(",");
                QueryStringObject.services = services;
            }
            if ("SearchedSelectedServicePoint" in localStorage) {
                let service_point_id = JSON.parse(localStorage.getItem("SearchedSelectedServicePoint")).dealer_id;
                QueryStringObject.service_point_id = service_point_id;
            }
            QueryStringObject.with = ["line_items"].toString()
            if (token) {
                ApiResource = apiService.get("/get-live-cart", QueryStringObject, { 'headers': { 'token': token} });
            } else {
                if(!TokenService.getGuestToken()) {
                    TokenService.setGuestToken()
                }
                anonymousId = TokenService.getGuestToken()
                QueryStringObject['anonymous_id'] = anonymousId;
                ApiResource = ApiService.get("/get-live-cart", {params: QueryStringObject});
            }

            ApiResource.then(data => {
                commit("setLiveCart", data.data)
                resolve();
            }).catch(error => {
                reject(error);
            })
        })

    }
}

const mutations = {
    csSetName(state, name) {
        state.cs_dealer.name = name;
    },
    csSetEmail(state, email) {
        state.cs_dealer.email = email;
    },
    csSetDate(state, date) {
        state.cs_dealer.appointment.date = date;
    },
    csSetTime(state, time) {
        state.cs_dealer.appointment.time = time;
    },
    csSetPhone(state, phone) {
        state.cs_dealer.phone = phone;
    },
    csSetAddress(state, address) {
        state.cs_dealer.address = address;
    },
    csSetCity(state, city) {
        state.cs_dealer.city = city;
    },
    csSetDealerId(state, dealer_id) {
        state.cs_dealer.dealer_id = dealer_id;
    },
    csSetTimeSlots(state, time_slots) {
        state.cs_dealer.time_slots = time_slots;
    },
    csSaveDealerToLocalStorage(state) {
        const cs_dealer = JSON.stringify(state.cs_dealer);
        const cs_dealer_encrypt = HashMake.encrypt(cs_dealer);
        localStorage.setItem("cs_dealer", cs_dealer_encrypt);
    },
    csSetDealerToLocalStorage(state) {
        if ('cs_dealer' in localStorage) {
            const dealer = localStorage.getItem('cs_dealer');
            const dealer_decrypt = HashMake.decrypt(dealer);
            state.cs_dealer = JSON.parse(dealer_decrypt);
        }
    },
    csRemoveDealerFromLocalStorage(state) {
        if ('cs_dealer' in localStorage) {
            localStorage.removeItem('cs_dealer');
        }
        var default_state = { name : "", email : "", phone : "", appointment : { date : "", time : "" }, address : "", city : "" };
        Object.assign(state, default_state)
    },
    setLoading(state, val) {
        state.cs_loader = val;
    },

    /*--Without Service Set Function--*/
    csWOSetName(state, name) {
        state.cs_dealer_without_service.name = name;
    },
    csWOSetEmail(state, email) {
        state.cs_dealer_without_service.email = email;
    },
    csWOSetDate(state, date) {
        state.cs_dealer_without_service.appointment.date = date;
    },
    csWOSetTime(state, time) {
        state.cs_dealer_without_service.appointment.time = time;
    },
    csWOSetPhone(state, phone) {
        state.cs_dealer_without_service.phone = phone;
    },
    csWOSetAddress(state, address) {
        state.cs_dealer_without_service.address = address;
    },
    csWOSetCity(state, city) {
        state.cs_dealer_without_service.city = city;
    },
    csWOSetDealerId(state, dealer_id) {
        state.cs_dealer_without_service.dealer_id = dealer_id;
    },
    csWOSetTimeSlots(state, time_slots) {
        state.cs_dealer_without_service.time_slots = time_slots;
    },
    csWOSaveDealerToLocalStorage(state) {
        const cs_dealer = JSON.stringify(state.cs_dealer_without_service);
        const cs_dealer_encrypt = HashMake.encrypt(cs_dealer);
        localStorage.setItem("cs_dealer_without_service", cs_dealer_encrypt);
    },
    csWOSetDealerToLocalStorage(state) {
        if ('cs_dealer_without_service' in localStorage) {
            const dealer = localStorage.getItem('cs_dealer_without_service');
            const dealer_decrypt = HashMake.decrypt(dealer);
            state.cs_dealer_without_service = JSON.parse(dealer_decrypt);
        }
    },
    csWORemoveDealerFromLocalStorage(state) {
        if ('cs_dealer_without_service' in localStorage) {
            localStorage.removeItem('cs_dealer_without_service');
        }
        var default_state = { name : "", email : "", phone : "", appointment : { date : "", time : "" }, address : "", city : "" };
        Object.assign(state.cs_dealer_without_service, default_state)
    },

    /*--FLAG--*/
    csSetIsWithService(state, bool) {
        state.is_with_service = bool;
        localStorage.setItem("is_with_service", bool ? 'yes' : 'no')
    },

    setLiveCart(state, data) {
        state.live_cart = data;
    }
}

export default {
    namespaced : true,
    state,
    getters,
    actions,
    mutations
}